import { DirectionProvider as RadixDirectionProvider } from "@radix-ui/react-direction";
import type { ReactNode } from "react";

export interface DirectionProviderProps {
  readonly children: ReactNode;
  readonly dir: "ltr" | "rtl";
}

export function DirectionProvider({ children, dir }: DirectionProviderProps) {
  return <RadixDirectionProvider dir={dir}>{children}</RadixDirectionProvider>;
}
